import { useState } from "react"
import usePagination from "../../hooks/usePagination"
import IssuersTable from "./components/IssuersTable"
import CreateOrUpdateIssuerFacility from "./components/CreateOrUpdateIssuerFacility"
import DeleteIssuerFacility from "./components/DeleteIssuerFacility"
import { generateFilter } from "../../utils"
import { usePatientIssuerData } from "../../hooks/usePatientIssuer"
import ApiError from "../../components/ApiError"
import Modal from "../../components/Modal"

const PatientIssuers = () => {
  const { limit, onPaginationChange, page, pagination } = usePagination()
  const [sorting, setSorting] = useState([{ id: "createdAt", desc: true }])
  const [filters, setFilters] = useState([])
  const [openAddModal, setOpenAddModal] = useState(false)
  const [editedIssuerId, setEditedIssuerId] = useState(null)
  const [deleteIssuerId, setDeleteIssuerId] = useState(null)

  const { data, isLoading, isError, error } = usePatientIssuerData({
    page,
    limit,
    sortBy: sorting.map((s) => `${s.id}:${s.desc ? "DESC" : "ASC"}`).join(","),
    filters: generateFilter(filters) || {},
  })

  const handleCloseDeleteModal = () => {
    setDeleteIssuerId(null)
  }

  const handleClose = () => {
    setEditedIssuerId(null)
    setOpenAddModal(false)
  }

  if (isError) {
    return (
      <div className="mt-4">
        <ApiError axiosError={error} />
      </div>
    )
  }

  return (
    <>
      <div className="px-4 py-2 flex justify-between items-center mt-2">
        <h1 className="text-2xl font-bold">Manage Patient Issuers</h1>
        <button
          className="bg-secondary hover:bg-secondary_dark text-white py-2 px-3 rounded flex items-center gap-2"
          onClick={() => setOpenAddModal(true)}
        >
          Add Patient Issuer
        </button>
      </div>
      <IssuersTable
        data={isLoading ? [] : data.data}
        filters={filters}
        loading={isLoading}
        pageCount={isLoading ? 0 : data.pages}
        pagination={pagination}
        setDeleteIssuerId={setDeleteIssuerId}
        setEditedIssuerId={setEditedIssuerId}
        setFilters={setFilters}
        setSorting={setSorting}
        sorting={sorting}
        onPaginationChange={onPaginationChange}
      />
      <Modal
        className="max-w-[70%] h-full"
        isOpen={openAddModal || Boolean(editedIssuerId)}
      >
        <CreateOrUpdateIssuerFacility
          filters={generateFilter(filters) || {}}
          issuerId={editedIssuerId ? editedIssuerId : null}
          limit={limit}
          page={page}
          sortBy={sorting
            .map((s) => `${s.id}:${s.desc ? "DESC" : "ASC"}`)
            .join(",")}
          onClose={handleClose}
        />
      </Modal>

      {deleteIssuerId && (
        <DeleteIssuerFacility
          filters={generateFilter(filters) || {}}
          issuerId={deleteIssuerId}
          limit={limit}
          page={page}
          sortBy={sorting
            .map((s) => `${s.id}:${s.desc ? "DESC" : "ASC"}`)
            .join(",")}
          onClose={handleCloseDeleteModal}
        />
      )}
    </>
  )
}

export default PatientIssuers
